import { CommonModule } from '@angular/common';
import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, ControlContainer, ControlValueAccessor, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';

import { NgxMaskModule } from 'ngx-mask';

@Component({
   standalone: true,
   selector: 'mnf-input-form',
   templateUrl: './input-form.component.html',
   imports: [CommonModule, ReactiveFormsModule, NgxMaskModule, MatTooltipModule,],
   providers: [
      {
         provide: NG_VALUE_ACCESSOR,
         multi: true,
         useExisting: forwardRef(() => InputFormComponent),
      },
   ]
})
export class InputFormComponent implements ControlValueAccessor, OnInit {
   /** Nombre que aparece arriba de input con etiqueta ´label´ */
   @Input() label: string;
   /** Placeholder de input */
   @Input() placeholder: string | number;
   /** Mensaje de error que aparecerá cuando el validador dé error */
   @Input() errMsg: string;
   /** FormControl del formulario */
   @Input() formControlName: string;
   /** Mensaje que aparecerá en un `tooltip` a lado del label */
   @Input() info: string;
   /** Tipo de input  */
   @Input() type = 'text';
   /** Input de texto con mayúsculas | @param string = 'true' | 'false' */
   @Input() upperCase = 'true';
   /** ID de input para alguna acción extra como para identificador del autocompletado */
   @Input() id: string;
   /** Estilo de un Input más delgado */
   @Input() flat: boolean | string;
   /** Máscara del Input | @default: `M{75}` = letras, números y espacios
    ** @doc https://www.npmjs.com/package/ngx-mask */
   @Input() mask = 'M{75}';
   /** Aceptar caracteres especiales para máscara */
   @Input() specialCharacters: string[] = [' '];
   /** Borrar caracteres especiales de máscara */
   @Input() dropSpecialCharacters: boolean;
   /** Opción de patrón nuevo para máscara de input */
   @Input() customPatterns: { [prop: string]: { pattern: RegExp, optional?: boolean } };
   /** Evento de salida en algún cambio al input a componente padre */
   @Output() changed = new EventEmitter<any>();

   /** Atributos extra para input */
   attr: any;
   /** Condición para hacer mayúsculas todos las letras */
   upper: boolean;
   /** Condición para input más delgado */
   _flat: boolean;
   /** FormControl propiedad del formulario */
   control: AbstractControl<any, any> | any;

   constructor(private controlContainer: ControlContainer) { }

   ngOnInit() {
      const defaultConf = this.mask === 'M{75}';
      this.upper = this.upperCase !== 'false';
      this._flat = !!this.flat;

      if (!this.customPatterns) {
         this.customPatterns = defaultConf ? { 'M': { pattern: new RegExp('[a-zA-Z \\d]'), optional: true } } : null;
      }

      if (typeof this.dropSpecialCharacters !== 'boolean') this.dropSpecialCharacters = !defaultConf;

      if (this.controlContainer && this.formControlName) {
         this.control = this.controlContainer.control.get(this.formControlName);
      }
   }

   /** Función que se ajecuta al cambiar el estado del input */
   changeModel(value: string | number) {
      if (this.upper && typeof value === 'string') {
         value = value.toUpperCase();

         if (value !== this.control.value) this.controlContainer.control.get(this.formControlName).setValue(value);
      }

      this.changed.next(value);
   }

   registerOnChange() { }

   registerOnTouched() { }

   writeValue() { }

   setDisabledState() { }
}
